import React from 'react';

import { Link } from 'react-router-dom';

import { Container } from './styleMenu';

function ModulosMenu() {
  return (
    <Container>
      <Link to="/menu/register" className="link">
        Cadastrar Menu
      </Link>
      <Link to="/menu/list" className="link">
        Listar menu
      </Link>
    </Container>
  );
}

export default ModulosMenu;
